/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Access_Creator_UnknownInputs */



/**
* | output |
* | --- |
* | "the person who set up this agent" |
*
* @param {Agent_Access_Creator_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_creator_unknown = /** @type {((inputs?: Agent_Access_Creator_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Creator_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("die Person, die diesen Agenten eingerichtet hat")
	return /** @type {LocalizedString} */ ("the person who set up this agent")
});